import React, { useCallback, lazy, Suspense, useState, useEffect } from 'react'
import API from '../../../services/API'
import { LinearProgress, Stack, Typography, Button } from '@mui/material'

// Lazy-load Stripe components and `loadStripe`
const loadStripe = async () => (await import('@stripe/stripe-js')).loadStripe
const EmbeddedCheckout = lazy(() =>
  import('@stripe/react-stripe-js').then((module) => ({
    default: module.EmbeddedCheckout,
  }))
)
const EmbeddedCheckoutProvider = lazy(() =>
  import('@stripe/react-stripe-js').then((module) => ({
    default: module.EmbeddedCheckoutProvider,
  }))
)

const SMSCredits = () => {
  const [stripePromise, setStripePromise] = useState(null)

  // Initialize Stripe only when needed
  const initializeStripe = async () => {
    if (!stripePromise) {
      const loadStripeLib = await loadStripe()
      setStripePromise(loadStripeLib(process.env.STRIPE_PK))
    }
  }

  const fetchClientSecret = useCallback(
    () =>
      API.post('/create-checkout-session-smscredits').then(
        (res) => res.data.clientSecret
      ),
    []
  )

  const options = { fetchClientSecret }

  useEffect(() => {
    initializeStripe()
  }, [])

  return (
    <Stack gap={2}>
      <Typography variant="h6">Purchase SMS Credits</Typography>
      {/* 
      {!stripePromise ? (
        <Button variant="contained" onClick={initializeStripe}>
          Initialize Checkout
        </Button>
      ) : ( */}
      <Suspense fallback={<LinearProgress />}>
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Suspense>
      {/* )} */}
    </Stack>
  )
}

export default SMSCredits
